<template>
  <div>
    <div class="right_menu">
      <div class="function">
        <router-link to="promptimage" class="router">
          <div class="p2i ts">
            <span> 文生图区</span>
          </div>
        </router-link>
        <router-link to="image2image" class="router">
          <div class="i2i ts">
            <span> 图生图区</span>
          </div>
        </router-link>
        <router-link to="fluxp2i" class="router">
          <div class="Fp2i ts">
            <span> Flux文生图</span>
          </div>
        </router-link>
        <router-link to="fluxi2i" class="router">
          <div class="Fi2i ts">
            <span> Flux图生图</span>
          </div>
        </router-link>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import setLocalStorage from '@/utils/setLocalStorage'
import theme from '@/utils/theme'
export default {
  name: 'GeneRate',
  data() {
    return {
      checkpoint_list: [],
      loras_list: [],
      day: theme.day,
      night: theme.night,
      theme: true,
      process_lock: true
    }
  },
  created() {
    this.theme = setLocalStorage.getItem('theme')
    if (this.theme === '' || this.theme === null) {
      this.theme = true
    }
  },
  mounted() {
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeyDown)
    this.$nextTick(() => {
      this.source_html()
      // 实验室
      const light = document.querySelector('#light')
      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      const daytips = document.querySelector('.daytips')
      // 搜索框
      const serarch = document.querySelector('.search')
      if (this.theme === false) {
        if (label) label.style.paddingLeft = '60%'
        if (darktips) darktips.style.opacity = 1
        if (daytips) daytips.style.opacity = 0
        if (light) light.style.color = 'gray'
        serarch.childNodes[0].style.border = '1px solid gray'
      } else {
        label.style.paddingLeft = '1%'
        darktips.style.opacity = 0
        daytips.style.opacity = 1
        light.style.color = 'black'
        serarch.childNodes[0].style.border = ''
      }
    })
  },
  beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    handleKeyDown(event) {
      // 检查是否按下了 Ctrl + b
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault() // 阻止默认行为（可选）
        this.$router.push({ path: '/' }) // 执行返回主页的操作
      }
    },
    // 初始化效果
    source_html() {
      const html = document.querySelector('html')
      // 夜间要切换的元素
      // 左侧导航
      const navigation = document.querySelectorAll('.navigation .nav-item')
      // 右边页面
      const right_menu = document.querySelectorAll('.right_menu')
      // 精品应用
      const delecacy = document.querySelector('.delicacy_title')

      // 风格样式
      const type_list = document.querySelector('.typeof')

      // 标题栏
      const header = document.querySelector('header')

      // 侧边栏
      const left = document.querySelector('.left_menu')

      // 搜索框
      const serarch = document.querySelector('.search')

      // 实验室
      const light = document.querySelector('#light')

      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      if (this.theme === false) {
        html.style.backgroundColor = this.night
        try {
          navigation.forEach(element => {
            element.style.color = 'gray'
          })
          right_menu.forEach(element => {
            element.style.opacity = 0.75
          })
          delecacy.style.color = 'gray'
          type_list.style.color = 'gray'
          type_list.childNodes.forEach(element => {
            element.style.color = 'gray'
          })

          header.childNodes.forEach(item => {
            item.style.opacity = 0.7
          })
          header.style.borderBottom = '1px solid gray'

          left.style.borderRight = '1px solid gray'
          serarch.childNodes[0].style.border = '1px solid gray'
          light.children[0].style.color = 'gray'

          label.style.paddingLeft = '60%'
          darktips.style.opacity = 1
        } catch (error) {
        }
      } else {
        html.style.backgroundColor = this.day
        try {
          navigation.forEach(element => {
            element.style.color = ''
          })
          right_menu.forEach(element => {
            element.style.opacity = 1
          })
          delecacy.style.color = ''
          type_list.style.color = ''
          type_list.childNodes.forEach(element => {
            element.style.color = ''
          })
          header.childNodes.forEach(item => {
            item.style.opacity = 1
          })
          header.style.borderBottom = ''
          left.style.borderRight = ''
          serarch.childNodes[0].style.border = ''
          light.children[0].color = 'black'

          label.style.paddingLeft = '4%'
          darktips.style.opacity = 0
        } catch (e) {
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.router-link-active {
  transition: all 0.5s;
  background-color: @morejoy;
  border-radius: 15px;
}

.router-link-active .ts span {
  color: @font_white;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 25px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.right_menu {
  width: calc(100vw - 360px);
  height: calc(100vh - 95px);
  overflow-y: scroll;
  overflow-x: hidden;
  color: @font_white;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;
  padding: 10px;

  .function {
    display: flex;
    height: 80px;

    .router {
      flex: 1;
      text-decoration: none;
      color: @font_gray;

      .p2i,
      .i2i,
      .Fp2i,
      .Fi2i {
        font-family: "icomoon";
        text-align: center;
        border-radius: 15px;
        font-size: 25px;
        cursor: pointer;
        border: 2px dashed transparent;

        span {
          display: inline-block;
          line-height: 76px;
          font-family: "icomoon";
        }

        &:hover {
          transition: all 0.5s;
          border: 2px dashed @morejoy;
        }
      }
    }
  }
}
</style>
